import { Button, ButtonProps, Form, FormProps } from "antd";
import { HTMLAttributes, ReactNode } from "react";
import { CustomModalProps } from "../../types";
import CustomModal from "./CustomModal";

interface Props<T> extends HTMLAttributes<HTMLDivElement> {
  formProps?: FormProps;
  buttonProps?: ButtonProps;
  isUpdate?: boolean;
  buttonText?: string;
  viewMood?: string;
  hideBtn?: boolean;
  disabled?: boolean;
  showDraft?: boolean;
  isDraft?: boolean;
  disabledSubmit?: boolean;
  children: ReactNode;
  handleDraft?: (val: boolean) => void;
  onFinish: (props: T) => void;
  className?: string;
  maxWidth?: number | string;
  position?: "start" | "center" | "end";
}

type FormModalProps<T> = Props<T> & CustomModalProps;

export default function FormModal<T>({
  formProps,
  buttonProps,
  isUpdate,
  buttonText = "Add",
  hideBtn,
  disabled,
  disabledSubmit,
  children,
  width = 400,
  isDraft,
  showDraft,
  onFinish,
  handleClose,
  handleDraft,
  position = "end",
  ...rest
}: FormModalProps<T>) {
  return (
    <CustomModal width={width} handleClose={handleClose} {...rest}>
      <Form
        onFinish={onFinish}
        requiredMark={false}
        className="custom-form"
        layout="vertical"
        size="large"
        {...formProps}
      >
        <div>{children}</div>
        {!hideBtn ? (
          <div className={`w-full gap-2 mt-6 flex justify-${position}`}>
            <Button
              onClick={() => handleClose()}
              disabled={disabled}
              className="cancel-btn"
            >
              Cancel
            </Button>
            {showDraft ? (
              <Button
                disabled={disabled}
                className="draft_btn"
                htmlType="submit"
                loading={isDraft && disabled}
                onClick={() => handleDraft && handleDraft(true)}
              >
                Save as Draft
              </Button>
            ) : null}
            <Button
              type="primary"
              disabled={disabledSubmit || disabled}
              htmlType="submit"
              loading={!isDraft && disabled}
              onClick={() => handleDraft && handleDraft(false)}
              {...buttonProps}
            >
              {buttonText}
            </Button>
          </div>
        ) : null}
      </Form>
    </CustomModal>
  );
}
